import {eActionType, getActionId} from '@common/actions/action-types';
import { eActionTemplate } from '@common/request_enums';
import {String} from '@common/string-extensions';
import {TranslateService} from '@ngx-translate/core';

export class ActionShared {
    static getTemplate(type: eActionType): eActionTemplate
    {
        switch (type)
        {
            case eActionType.Authorization: return eActionTemplate.authorization;
            case eActionType.ExchangeStart: return eActionTemplate.exchange;
            case eActionType.TransactionStart: return eActionTemplate.transaction;
        }
        return eActionTemplate.action;
    }

    static async extractValue(value: string, translate: TranslateService, ...args: string[]): Promise<string>
    {
        if (String.isNullOrWhiteSpace(value)) {
            return String.Empty;
        }

        try
        {
            return await translate.get(String.Format(value, ...args)).toPromise();
        }
        catch (err)
        {
            return String.Empty;
        }
    }
}
